module.exports = __webpack_public_path__ + "img/pro_six_1.ec088b35.jpg";